import React from 'react'
import { Badge } from 'evergreen-ui'
import { FaCheck } from 'react-icons/fa'
import { useStatusContent } from '../../../config/roundContent'

const StatusRegister_2 = ({ DataRegister }) => {
  const row = DataRegister?.[0] || {}
  const { statusContent } = useStatusContent(row.ROB_ID, "2")
  const title = statusContent.titleText || 'เข้ารับการสอบสัมภาษณ์'

  return (
    <Badge
      color="green"
      height="100%"
      paddingY={4}
      paddingX={5}
      fontSize={16}
      fontFamily=""
    >
      <FaCheck /> {title}
      {statusContent.bodyText ? ` — ${statusContent.bodyText}` : ''}
    </Badge>
  )
}

export default StatusRegister_2
